import supabase from "../supabase";

// Returns an Authorization header carrying the current user's Supabase
// session token, or {} if there's no session. Spread into fetch() headers
// (or an SDK client's default headers) for any call to our own backend.
export async function getAuthHeader() {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}
